import React, { useState, useEffect } from 'react';

const API_BASE = 'https://api.pascolo.com.ar/api';

export default function VistaStock() {
  const [stock, setStock] = useState([]);
  const [cargando, setCargando] = useState(true);

  // Estados para la cascada de selección
  const [productoSel, setProductoSel] = useState('');
  const [formatoSel, setFormatoSel] = useState('');

  const cargarStock = async () => {
    try {
      const res = await fetch(`${API_BASE}/admin/stock-consolidado`);
      if (res.ok) {
        const data = await res.json();
        setStock(data);
      }
    } catch (error) {
      console.error("Error cargando el stock detallado:", error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarStock();
  }, []);

  // ============================================
  // AJUSTE MANUAL DE STOCK (Alta / Baja)
  // ============================================
  const [productosAdmin, setProductosAdmin] = useState([]);
  const [presentacionesAdmin, setPresentacionesAdmin] = useState([]);
  const [bucketsDisponibles, setBucketsDisponibles] = useState([]);

  const [ajusteTipo, setAjusteTipo] = useState('alta'); // 'alta' | 'baja'
  const [ajusteProductoId, setAjusteProductoId] = useState('');
  const [ajustePresentacionId, setAjustePresentacionId] = useState('');
  const [ajusteDias, setAjusteDias] = useState('0');
  const [ajusteCantidad, setAjusteCantidad] = useState('');
  const [ajusteMotivo, setAjusteMotivo] = useState('');
  const [guardandoAjuste, setGuardandoAjuste] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/admin/productos`)
      .then(res => res.json())
      .then(data => setProductosAdmin(Array.isArray(data) ? data.filter(p => p.activo) : []))
      .catch(err => console.error("Error cargando productos para ajuste:", err));
  }, []);

  const handleAjusteProductoChange = (e) => {
    const id = e.target.value;
    setAjusteProductoId(id);
    setAjustePresentacionId('');
    setPresentacionesAdmin([]);
    setBucketsDisponibles([]);

    if (!id) return;
    fetch(`${API_BASE}/admin/productos/${id}/presentaciones`)
      .then(res => res.json())
      .then(data => setPresentacionesAdmin(Array.isArray(data) ? data : []))
      .catch(err => console.error("Error cargando presentaciones para ajuste:", err));
  };

  const cargarBucketsDisponibles = (presentacionId) => {
    if (!presentacionId) {
      setBucketsDisponibles([]);
      return;
    }
    fetch(`${API_BASE}/admin/stock-fisico/${presentacionId}`)
      .then(res => res.json())
      .then(data => setBucketsDisponibles(Array.isArray(data) ? data : []))
      .catch(err => console.error("Error cargando stock físico disponible:", err));
  };

  const handleAjustePresentacionChange = (e) => {
    const id = e.target.value;
    setAjustePresentacionId(id);
    cargarBucketsDisponibles(id);
  };

  const limpiarFormularioAjuste = () => {
    setAjusteCantidad('');
    setAjusteMotivo('');
    setAjusteDias('0');
  };

  const handleSubmitAjuste = async (e) => {
    e.preventDefault();

    if (!ajustePresentacionId || !ajusteCantidad || Number(ajusteCantidad) <= 0) {
      alert("Elegí producto, formato y una cantidad mayor a 0.");
      return;
    }

    const endpoint = ajusteTipo === 'alta' ? 'alta' : 'baja';
    const confirmacion = ajusteTipo === 'alta'
      ? `¿Confirmás cargar ${ajusteCantidad} unidades?`
      : `¿Confirmás dar de baja ${ajusteCantidad} unidades? Esta acción resta stock vendible por la web.`;

    if (!window.confirm(confirmacion)) return;

    setGuardandoAjuste(true);
    try {
      const res = await fetch(`${API_BASE}/admin/stock/${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          presentacion_id: ajustePresentacionId,
          dias_maduracion: ajusteDias,
          cantidad: ajusteCantidad,
          motivo: ajusteMotivo
        })
      });

      const data = await res.json();

      if (res.ok) {
        alert(data.mensaje || 'Listo.');
        limpiarFormularioAjuste();
        cargarBucketsDisponibles(ajustePresentacionId);
        cargarStock(); // Refresca la tabla de consulta de lotes
      } else {
        alert(data.error || 'No se pudo procesar el ajuste de stock.');
      }
    } catch (error) {
      console.error("Error al ajustar stock:", error);
      alert('Error de conexión al ajustar el stock.');
    } finally {
      setGuardandoAjuste(false);
    }
  };

  // 1. Extraer lista de productos únicos disponibles en stock
  const productosUnicos = Array.from(
    new Set(stock.map(item => item.producto))
  ).sort();

  // 2. Filtrar formatos disponibles SOLO para el producto seleccionado
  const formatosDisponibles = Array.from(
    new Set(
      stock
        .filter(item => item.producto === productoSel)
        .map(item => item.formato)
    )
  ).sort();

  // 3. Filtrar los lotes finales basados en Producto + Formato seleccionado
  const lotesFinales = stock.filter(item => 
    item.producto === productoSel && item.formato === formatoSel
  );

  // Resetear el formato si el producto cambia
  const handleProductoChange = (e) => {
    setProductoSel(e.target.value);
    setFormatoSel(''); // Limpia el segundo selector
  };

  if (cargando) {
    return (
      <div style={{ padding: '30px', textAlign: 'center', fontFamily: 'sans-serif', color: '#666' }}>
        <h3>Cargando existencias de cámara...</h3>
      </div>
    );
  }

  return (
    <div style={{ padding: '30px', fontFamily: 'sans-serif', backgroundColor: '#fff', borderRadius: '8px' }}>
      
      {/* Encabezado */}
      <div style={{ marginBottom: '25px', borderBottom: '2px solid #000', paddingBottom: '15px' }}>
        <h2 style={{ margin: 0, color: '#000', fontWeight: '800', fontSize: '24px' }}>CONSULTA DE LOTES</h2>
        <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '14px' }}>Seleccioná un producto y su presentación para desglosar los lotes en cámara.</p>
      </div>

      {/* Selectores en Cascada */}
      <div style={{ display: 'flex', gap: '20px', marginBottom: '30px', backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #eee' }}>
        
        {/* Selector 1: Producto */}
        <div style={{ flex: 1 }}>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '8px', fontSize: '14px', color: '#333' }}>
            1. Seleccionar Producto
          </label>
          <select 
            value={productoSel}
            onChange={handleProductoChange}
            style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '15px', backgroundColor: '#fff', cursor: 'pointer' }}
          >
            <option value="">-- Elegir Queso --</option>
            {productosUnicos.map(prod => (
              <option key={prod} value={prod}>{prod}</option>
            ))}
          </select>
        </div>

        {/* Selector 2: Formato (Se habilita solo si hay producto seleccionado) */}
        <div style={{ flex: 1 }}>
          <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '8px', fontSize: '14px', color: productoSel ? '#333' : '#999' }}>
            2. Seleccionar Formato
          </label>
          <select 
            value={formatoSel}
            onChange={(e) => setFormatoSel(e.target.value)}
            disabled={!productoSel}
            style={{ 
              width: '100%', 
              padding: '12px', 
              borderRadius: '6px', 
              border: '1px solid #ccc', 
              fontSize: '15px', 
              backgroundColor: productoSel ? '#fff' : '#e9ecef', 
              cursor: productoSel ? 'pointer' : 'not-allowed' 
            }}
          >
            <option value="">-- Elegir Formato --</option>
            {formatosDisponibles.map(formato => (
              <option key={formato} value={formato}>{formato}</option>
            ))}
          </select>
        </div>

      </div>

      {/* Panel de Resultados: Listado de Lotes */}
      <div>
        {!productoSel ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontStyle: 'italic', backgroundColor: '#fafafa', borderRadius: '6px', border: '1px solid #eee' }}>
            Esperando selección de producto...
          </div>
        ) : !formatoSel ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontStyle: 'italic', backgroundColor: '#fafafa', borderRadius: '6px', border: '1px solid #eee' }}>
            Por favor, seleccioná un formato para ver los lotes disponibles.
          </div>
        ) : lotesFinales.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#dc3545', fontWeight: 'bold' }}>
            No hay stock físico para esta combinación en este momento.
          </div>
        ) : (
          <div>
            <h3 style={{ fontSize: '16px', fontWeight: '700', marginBottom: '15px', color: '#333' }}>
              Lotes en Cámara para: <span style={{ color: '#009ee3' }}>{productoSel} ({formatoSel})</span>
            </h3>
            
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
              <thead>
                <tr style={{ backgroundColor: '#000', color: '#FFF' }}>
                  <th style={{ padding: '12px 15px', fontSize: '14px', fontWeight: '700', textAlign: 'center' }}>CÓDIGO DE LOTE</th>
                  <th style={{ padding: '12px 15px', fontSize: '14px', fontWeight: '700', textAlign: 'center' }}>FECHA ELABORACIÓN</th>
                  <th style={{ padding: '12px 15px', fontSize: '14px', fontWeight: '700', textAlign: 'center' }}>TIEMPO DE MADURACIÓN</th>
                  <th style={{ padding: '12px 15px', fontSize: '14px', fontWeight: '700', textAlign: 'right' }}>UNIDADES EN STOCK</th>
                </tr>
              </thead>
              <tbody>
                {lotesFinales.map((item, index) => {
                  // Formatear fecha de elaboración para que quede prolija (DD/MM/AAAA)
                  const fecha = item.fecha_elaboracion 
                    ? new Date(item.fecha_elaboracion).toLocaleDateString('es-AR', {
                        day: '2-digit', month: '2-digit', year: 'numeric'
                      })
                    : '-';

                  return (
                    <tr 
                      key={item.codigo_lote}
                      style={{ 
                        borderBottom: '1px solid #E0E0E0', 
                        backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F9F9F9' 
                      }}
                    >
                      <td style={{ padding: '15px', textAlign: 'center', fontFamily: 'monospace', fontWeight: 'bold', fontSize: '15px', color: '#333' }}>
                        {item.codigo_lote}
                      </td>
                      <td style={{ padding: '15px', textAlign: 'center', color: '#555' }}>
                        {fecha}
                      </td>
                      <td style={{ padding: '15px', textAlign: 'center' }}>
                        <span style={{ 
                          backgroundColor: item.dias_maduracion > 25 ? '#E8F5E9' : '#FFF3E0', 
                          color: item.dias_maduracion > 25 ? '#2E7D32' : '#E65100', 
                          padding: '5px 12px', 
                          borderRadius: '20px', 
                          fontSize: '13px', 
                          fontWeight: 'bold' 
                        }}>
                          {item.dias_maduracion} {item.dias_maduracion === 1 ? 'día' : 'días'}
                        </span>
                      </td>
                      <td style={{ padding: '15px', textAlign: 'right', fontWeight: '800', fontSize: '16px', color: '#000' }}>
                        {item.unidades_stock} u.
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ============================================ */}
      {/* PANEL: AJUSTE MANUAL DE STOCK (Alta / Baja)    */}
      {/* ============================================ */}
      <div style={{ marginTop: '40px', borderTop: '2px solid #000', paddingTop: '20px' }}>
        <h2 style={{ margin: 0, color: '#000', fontWeight: '800', fontSize: '24px' }}>AJUSTAR STOCK MANUALMENTE</h2>
        <p style={{ margin: '5px 0 20px 0', color: '#666', fontSize: '14px' }}>
          Para cargar o descontar stock que no pasó por la app de producción (ventas fuera de la web, mermas, correcciones).
        </p>

        {/* Selector Alta / Baja */}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
          <button
            type="button"
            onClick={() => setAjusteTipo('alta')}
            style={{
              flex: 1, padding: '12px', borderRadius: '6px', border: 'none', cursor: 'pointer',
              fontWeight: 'bold', fontSize: '14px',
              backgroundColor: ajusteTipo === 'alta' ? '#2d5a27' : '#e9ecef',
              color: ajusteTipo === 'alta' ? '#fff' : '#333'
            }}
          >
            + Cargar stock (Alta)
          </button>
          <button
            type="button"
            onClick={() => setAjusteTipo('baja')}
            style={{
              flex: 1, padding: '12px', borderRadius: '6px', border: 'none', cursor: 'pointer',
              fontWeight: 'bold', fontSize: '14px',
              backgroundColor: ajusteTipo === 'baja' ? '#f44336' : '#e9ecef',
              color: ajusteTipo === 'baja' ? '#fff' : '#333'
            }}
          >
            − Dar de baja stock
          </button>
        </div>

        <form onSubmit={handleSubmitAjuste} style={{ backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #eee' }}>
          <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '15px' }}>

            <div style={{ flex: '1 1 200px' }}>
              <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px', fontSize: '13px', color: '#333' }}>Producto</label>
              <select
                value={ajusteProductoId}
                onChange={handleAjusteProductoChange}
                required
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
              >
                <option value="">-- Elegir producto --</option>
                {productosAdmin.map(p => (
                  <option key={p.id} value={p.id}>{p.nombre}</option>
                ))}
              </select>
            </div>

            <div style={{ flex: '1 1 200px' }}>
              <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px', fontSize: '13px', color: ajusteProductoId ? '#333' : '#999' }}>Formato</label>
              <select
                value={ajustePresentacionId}
                onChange={handleAjustePresentacionChange}
                disabled={!ajusteProductoId}
                required
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', backgroundColor: ajusteProductoId ? '#fff' : '#e9ecef' }}
              >
                <option value="">-- Elegir formato --</option>
                {presentacionesAdmin.map(pres => (
                  <option key={pres.id} value={pres.id}>{pres.formato} ({pres.peso_estimado_kg} kg)</option>
                ))}
              </select>
            </div>

            <div style={{ flex: '1 1 160px' }}>
              <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px', fontSize: '13px', color: '#333' }}>Maduración</label>
              <select
                value={ajusteDias}
                onChange={(e) => setAjusteDias(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
              >
                <option value="0">Fresco</option>
                <option value="30">30 días</option>
                <option value="60">60 días</option>
              </select>
            </div>

            <div style={{ flex: '1 1 140px' }}>
              <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px', fontSize: '13px', color: '#333' }}>Cantidad</label>
              <input
                type="number"
                min="1"
                step="1"
                value={ajusteCantidad}
                onChange={(e) => setAjusteCantidad(e.target.value)}
                required
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }}
              />
            </div>

          </div>

          {/* Stock disponible en ese bucket, solo relevante para dar de baja */}
          {ajusteTipo === 'baja' && ajustePresentacionId && (
            <div style={{ marginBottom: '15px', fontSize: '13px', color: '#555' }}>
              Disponible actualmente: {
                bucketsDisponibles.length === 0
                  ? 'sin stock registrado'
                  : bucketsDisponibles.map(b => `${b.dias_maduracion === 0 ? 'Fresco' : b.dias_maduracion + ' días'}: ${b.cantidad_unidades_disponibles} u.`).join(' · ')
              }
            </div>
          )}

          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px', fontSize: '13px', color: '#333' }}>Motivo (opcional)</label>
            <input
              type="text"
              placeholder={ajusteTipo === 'alta' ? 'Ej: stock encontrado en cámara, corrección de inventario...' : 'Ej: venta directa en fábrica, merma, corrección...'}
              value={ajusteMotivo}
              onChange={(e) => setAjusteMotivo(e.target.value)}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }}
            />
          </div>

          <button
            type="submit"
            disabled={guardandoAjuste}
            style={{
              padding: '12px 25px', borderRadius: '6px', border: 'none', cursor: guardandoAjuste ? 'not-allowed' : 'pointer',
              fontWeight: 'bold', fontSize: '14px', color: '#fff',
              backgroundColor: ajusteTipo === 'alta' ? '#2d5a27' : '#f44336',
              opacity: guardandoAjuste ? 0.7 : 1
            }}
          >
            {guardandoAjuste ? 'Guardando...' : (ajusteTipo === 'alta' ? 'Cargar stock' : 'Dar de baja')}
          </button>
        </form>
      </div>

    </div>
  );
}